const chunkMapping = {
	"70": [
		5070
	],
	"84": [
		8084
	],
	"116": [
		116
	],
	"187": [
		6187
	],
	"303": [
		7303
	],
	"341": [
		341
	],
	"404": [
		404
	],
	"596": [
		4596
	],
	"605": [
		4605
	],
	"678": [
		9678
	],
	"852": [
		2852
	]
};
const idToExternalAndNameMapping = {
	"116": [
		"default",
		"./CheckoutOrderContentPayment",
		8398
	],
	"341": [
		"default",
		"./Checkout",
		8398
	],
	"404": [
		"default",
		"./Product",
		4770
	],
	"2852": [
		"default",
		"./OrderConfirmation",
		8398
	],
	"4596": [
		"default",
		"./CheckoutOrderInNavbar",
		8398
	],
	"4605": [
		"default",
		"./InitCart",
		8398
	],
	"5070": [
		"default",
		"./InitProduct",
		4770
	],
	"6187": [
		"default",
		"./OrderButtonToggle",
		8398
	],
	"7303": [
		"default",
		"./AccessoriesSliders",
		4770
	],
	"8084": [
		"default",
		"./CheckoutOrderInNavbarDesktop",
		8398
	],
	"9678": [
		"default",
		"./OrderErrorModal",
		8398
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}